module.exports = __webpack_public_path__ + "img/Tags Icon (2).50cf3374.svg";